import Axios from "axios";
import baseURL from "commonUtils/globalAPISettings";

const axios = Axios.create({});

axios.defaults.timeout = 120000; // This is a miliseconds equivalent 2 minutes

axios.interceptors.request.use(
  async function (config) {
    config.baseURL = baseURL;
    return config;
  },
  async function (error) {
    return await Promise.reject(error);
  },
);

axios.interceptors.response.use(
  async response => {
    return response;
  },
  async error => {
    return await Promise.reject(error);
  },
);

export default axios;
